/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import * as R from 'ramda';
/**
 * The internal dependencies.
 */
import FlexRootWrapper from '../../components/general/flex-root';
import Bar from '../../containers/disponent/bar';
import Sidebar from '../../containers/disponent/sidebar';
import Form from '../../containers/disponent/form';
import {tasksDeselect} from '../../store/tasks/actions';
import {getTasksCurrent} from '../../store/tasks/selectors';
import {callRoute} from '../../common/api';
import moment from "moment";
import {tasksUpdate} from "../../store/tasks/actions";
import {dispoGetDepartments, dispoGetDepartmentsConfig, dispoGetUser, dispoTaskUpdate} from "../../store/dispo/actions";
import {getUsers} from "../../store/dispo/selectors";
import {getcurrentChildren} from "../../store/tasks/selectors";
import {ts_translate} from "../../common/clientTranslate";

const ContentWrapper = styled(FlexRootWrapper)`
	flex-direction: row;
`;


class Task extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            image: ''
        }
    }

    async componentDidMount() {

        const {dispoGetUser, dispoGetDepartments, dispoGetDepartmentsConfig, task} = this.props;

        dispoGetUser();
        dispoGetDepartments();
        dispoGetDepartmentsConfig(task);

        await callRoute(['getTasksSteps', {
            client: this.props.task.order_client,
            erpnumber: this.props.task.erpnumber
        }]).then((response) => {
            if (response.data._embedded) {
                this.setState({
                    materials: response.data._embedded.instruction[0].content,
                    image: response.data._embedded.instruction[0]._links.resourcesEntity.href
                });
            }
        })
    }

    setDate(setDate){
        const {task, dispoTaskUpdate} = this.props;
        dispoTaskUpdate(task.id, {date: setDate});
    }

    render() {
        const {task, tasksDeselect, children} = this.props;
        const {materials} = this.state;
        const {close} = this.props;
        const departments = R.join(',', task.departmentEntityList);

        return (
            <FlexRootWrapper>
                <Bar
                    longNumber={task.erpnumber}
                    task={task}
                    onClose={tasksDeselect}
                />

                <ContentWrapper>
                    <Sidebar
                        taskHeadLine={ts_translate('Disponent')}
                        taskImage={this.state.image}
                        taskShortNumber={task.erpnumber}
                        taskTotalQuantity={task.order_quantity}
                        taskCustomer={task.order_client}
                        taskDate={task.date}
                        taskDepartments={departments}
                        taskStep={task.step}
                        materials={materials}
                        setDate={(date)=>{this.setDate(date)}}
                        children={children}
                        taskDeliveryDate={task.order_deadline}
                        task={task}
                    />
                    <Form
                        taskStep={task.step}
                        materials={materials}
                    />
                </ContentWrapper>
            </FlexRootWrapper>
        );
    }
}

export default connect(
    (state) => ({
        task: getTasksCurrent(state),
        users: getUsers(state),
        children: getcurrentChildren(state),
    }), {
        tasksDeselect,
        tasksUpdate,
        dispoTaskUpdate,
        dispoGetUser,
        dispoGetDepartments,
        dispoGetDepartmentsConfig,
    }
)(Task);



// WEBPACK FOOTER //
// ./src/containers/disponent/index.js